export default {
  statisticsData: {
    homepage: {
      en: [
        { number: '+ 200', info: 'Clients', countries: '' },
        { number: '4', info: 'Countries with projects: ', countries: 'Spain, Mexico, Peru and USA' },
        { number: '+ 750', info: 'Employees', countries: '' },
      ],
      es: [
        { number: '+ 200', info: 'Clientes', countries: '' },
        { number: '4', info: 'Países con proyectos: ', countries: 'España, México, Perú y EEUU' },
        { number: '+ 750', info: 'Empleados', countries: '' },
      ],
    },
    innovationpage: {
      en: [
        { number: '+ 20', info: 'Different countries', countries: '' },
        { number: '130', info: 'Millions in investments', countries: '' },
        { number: '74', info: 'Participating companies', countries: '' },
        { number: '2', info: 'Years of duration', countries: '' },
      ],
      es: [
        { number: '+ 20', info: 'Países diferentes', countries: '' },
        { number: '130', info: 'Millones de inversión ', countries: '' },
        { number: '74', info: 'Empresas participantes', countries: '' },
        { number: '2', info: 'Años de duración', countries: '' },
      ],
    },
    generationk: {
      en: [
        { number: '44', info: 'Número de participantes', countries: '' },
        { number: '5', info: 'Ediciones', countries: '' },
        { number: '70%', info: 'Mujeres', countries: '' },
      ],
      es: [
        { number: '44', info: 'Número de participantes', countries: '' },
        { number: '5', info: 'Ediciones', countries: '' },
        { number: '70%', info: 'Mujeres', countries: '' },
      ],
    },
  },
};
